function initHeroWordRotation()
{
    var rotating = document.querySelector( ".we-hero-rotating" );

    if ( !rotating )
    {
        return;
    }

    var words = rotating.querySelectorAll( ".we-hero-word" );

    if ( words.length < 2 )
    {
        return;
    }

    var speed = parseInt( rotating.style.getPropertyValue( "--rotation-speed" ) ) || 2000;
    var current = 0;

    function showNextWord()
    {
        words[ current ].style.cssText = "opacity:0;position:absolute;left:0;top:0;white-space:nowrap;animation:none !important;z-index:0";
        current = ( current + 1 ) % words.length;
        words[ current ].style.cssText = "opacity:1;position:relative;left:0;top:0;white-space:nowrap;animation:none !important;z-index:1";
    }

    for ( var i = 0; i < words.length; i++ )
    {
        words[ i ].style.cssText = "opacity:0;position:absolute;left:0;top:0;white-space:nowrap;animation:none !important;z-index:0";
    }

    words[ 0 ].style.cssText = "opacity:1;position:relative;left:0;top:0;white-space:nowrap;animation:none !important;z-index:1";

    setInterval( showNextWord, speed );
}

document.addEventListener( "DOMContentLoaded", initHeroWordRotation );
